module.exports = __webpack_public_path__ + "img/logo.12625140.png";